module.exports = __webpack_public_path__ + "static/media/tikkie.49589dc4.png";